import { HttpErrorResponse } from '@angular/common/http';
import HTTP_STATUS_CODES from '../enums/HttpStatusCodesEnum';
import { BaseResponseStatus } from "../models/BaseResponseDto.model";

export enum ErrorType {
  // SameNameException = 1, no longer exist. AlreadyExistsException is used instead.

  AlreadyExistsException = 2,
  BadFileFormatException = 3,
  UserOutOfScopeException = 4,
  ValueNotSupportedException = 5,
  CurrencyNotSupportedException = 6,
  PaymentRequestIsAssignedToOtherClientException = 7,
  RecordNotFoundException = 8,
  CovercyInvalidOperationException = 9,
  DataUsedForOperationWasChangedException = 10,
  SuspendedAccountException = 11,
  preconditionFailed = 12,
  NoAccessToResourcePermission = 13,
  MaxTriesReachedException = 14
}

export interface ErrorData {
  name: string;
  data: string;
  message: string;
}

export class ErrorMatcher {
  private static MFA_MESSAGE = '2fa not verified';

  static isError(err: any, errorType: ErrorType) {
    if (errorType === ErrorType.NoAccessToResourcePermission) {
      return err?.responseStatus !== BaseResponseStatus.Success;
    }

    try {
      const error = err as HttpErrorResponse;
      const errorData = error.error as ErrorData;
      // const errorData = JSON.parse(error.error.message);
      if (!errorData || (!errorData.message && !errorData.name)) {
        return false;
      }

      switch (errorType) {
        case ErrorType.RecordNotFoundException:
          return error.status === HTTP_STATUS_CODES.NOT_FOUND && errorData?.name === 'RecordNotFoundException';
        case ErrorType.AlreadyExistsException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'AlreadyExistsException';
        case ErrorType.BadFileFormatException:
          return error.status === HTTP_STATUS_CODES.UNSUPPORTED_MEDIA_TYPE && errorData?.name === 'BadFileFormatException';
        case ErrorType.UserOutOfScopeException:
          return error.status === HTTP_STATUS_CODES.CONFLICT && errorData?.name === 'UserOutOfScopeException';
        case ErrorType.ValueNotSupportedException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'ValueNotSupportedException';
        case ErrorType.CurrencyNotSupportedException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'CurrencyNotSupportedException';
        case ErrorType.PaymentRequestIsAssignedToOtherClientException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'PaymentRequestIsAssignedToOtherClientException';
        case ErrorType.CovercyInvalidOperationException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'CovercyInvalidOperationException';
        case ErrorType.DataUsedForOperationWasChangedException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'DataUsedForOperationWasChangedException';
        case ErrorType.SuspendedAccountException:
          return (error.status === HTTP_STATUS_CODES.BAD_REQUEST && errorData?.name === 'SuspendedAccountException') ||
            (error.status === HTTP_STATUS_CODES.FORBIDDEN && error.error === 'Suspended');
        case ErrorType.preconditionFailed:
          return error.status === HTTP_STATUS_CODES.PRECONDITION_FAILED && errorData?.message === this.MFA_MESSAGE;
        case ErrorType.MaxTriesReachedException:
          return error.status === HTTP_STATUS_CODES.BAD_REQUEST && JSON.parse(errorData.message)?.data?.startsWith('Rejected');
        default:
          return false;
      }
    } catch {
      return false;
    }
  }
}
